export default "__VITE_ASSET__39a17dcb__"